module.exports = __webpack_public_path__ + "static/media/employee_banner_bg.e54fc955.jpg";